export default __webpack_public_path__ + "static/media/lipstick-hot-autumn.d4538d50.png";